import template from './loading-indicator.html';

const LoadingIndicator = {
  dots: 'dots',
  spinner: 'spinner',
  spinnerDouble: 'spinner-double'
};

export const loadingIndicatorComponent = {
  name: 'loadingIndicator',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  controller: function() {
    'ngInject';
    // Indicator defaults to spinner
    if (!this.indicator) {
      this.indicator = LoadingIndicator.spinner;
    }
  },
  bindings: {
    isLoading: '<',
    indicator: '@'
  }
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-loading-indicator/src/loading-indicator.component.js